/*
  Sets the mobile menu drawer's top offset from the header's own real,
  currently-rendered bounding box right after the drawer opens - not from
  --header-group-height, which is a value computed by a ResizeObserver
  (assets/header.js) that can be stale or racy relative to scroll/sticky
  state changes happening at the same moment (opening the drawer also
  engages scroll-lock and forces the sticky header to position: fixed, see
  sections/header.liquid - both of which can shift when that observer last
  fired relative to when this reads the header's actual position). Reading
  getBoundingClientRect() directly is always accurate regardless of that
  timing.

  Deferred two animation frames past the native <details> "toggle" event:
  header-drawer.js itself adds the .menu-open class (the thing that
  actually slides the drawer in) inside its own requestAnimationFrame, one
  frame after toggle fires. Measuring - which forces a synchronous layout
  reflow - in the same tick as toggle, before that class lands, risked
  contending with it and needing a second tap to visually catch up.
  Running after two frames instead guarantees this reads the fully
  settled, already-open layout.
*/
(function () {
  const container = document.getElementById('Details-menu-drawer-container');
  if (!container) return;

  function applyOffset() {
    if (!container.hasAttribute('open')) return;
    const header = document.querySelector('header-component') || document.querySelector('.header-section');
    if (!header) return;

    const bottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
    document.body.style.setProperty('--menu-drawer-offset', `${bottom}px`);
  }

  container.addEventListener('toggle', () => {
    requestAnimationFrame(() => requestAnimationFrame(applyOffset));
  });
})();
